module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/change-template-modal/change-template-modal.component.scss
// module id = ./src/app/widgets/widget-detail/change-template-modal/change-template-modal.component.scss
// module chunks = main